import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  size?: number;
}

export const UkraineFlag = ({ size = 40, ...props }: Props) => (
  <svg
    aria-hidden="true"
    width={size}
    height={size}
    style={{ borderRadius: "50%" }}
    viewBox="0 0 513 512"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_ukraine_flag)">
      <path d="M0.5 0H512.5V256H0.5V0Z" fill="#005BBB" />
      <path d="M0.5 256H512.5V512H0.5V256Z" fill="#FFD500" />
    </g>
    <defs>
      <clipPath id="clip0_ukraine_flag">
        <rect
          width="512"
          height="512"
          fill="white"
          transform="translate(0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);
